import { ReactNode } from 'react';
import './BordAcordeon.scss';

/**
 * Componente de acordeón que permite expandir y colapsar contenido
 * con animaciones suaves
 */
const BordAcordeon = ({
  children,
  isExpanded,
  customClassName = '',
  customContentClassName = ''
}: IBordAcordeon) => {
  return (
    <div className={`bordAcordeon ${customClassName}`}>
      <div className={`bordAcordeonContent ${isExpanded ? 'bordAcordeonContentExpanded' : 'bordAcordeonContentCollapsed'} ${customContentClassName}`}>
        {children}
      </div>
    </div>
  );
};

interface IBordAcordeon {
  children: ReactNode;
  isExpanded: boolean;
  customClassName?: string;
  customContentClassName?: string;
}

export default BordAcordeon;
